export class ChangeBlockForBuildingsDto {
  buildingIds: String[];
  blockId: string;

  constructor(data: { buildingIds: string[]; blockId: string }) {
    this.buildingIds = data.buildingIds;
    this.blockId = data.blockId;
  }
}
